class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const miniCartContainer = document.getElementById('mini-cart');
        if (miniCartContainer) {
          miniCartContainer.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        }
        document.dispatchEvent(new CustomEvent('cartdrawer:opened', { bubbles: true }));
      })
      .catch(e => {
        console.error('Error fetching mini-cart:', e);
      });
  }

  open() {
    if (!this.drawer) {
      this.drawer = document.querySelector('cart-drawer');
    }
    if (!this.drawer) return;

    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement && detailsElement.hasAttribute('open')) {
      return;
    }

    if (typeof this.drawer.openMenuDrawer === 'function') {
      this.drawer.openMenuDrawer();
    } else {
      this.drawer.setAttribute('open', '');
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      const targetEl = document.getElementById(section.id);
      if (targetEl && parsedState.sections && parsedState.sections[section.id]) {
        targetEl.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const targetNode = parsed.querySelector(selector);
    return targetNode ? targetNode.innerHTML : '';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart);
}